interface ExtendedHTMLElement extends HTMLElement {
  _observer?: IntersectionObserver
}

export const intersection = {
  mounted(el: ExtendedHTMLElement, binding: any) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          binding.value()
        }
      },
      {
        rootMargin: '50px'
      }
    )

    observer.observe(el)
    el._observer = observer
  },
  unmounted(el: ExtendedHTMLElement) {
    if (el._observer) {
      el._observer.disconnect()
    }
  }
} 